import { render, staticRenderFns } from "./organization-datasource-form.vue?vue&type=template&id=044c5415"
import script from "./organization-datasource-form.vue?vue&type=script&lang=js"
export * from "./organization-datasource-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports